import { render } from "./TheCard.vue?vue&type=template&id=22d50f3e&scoped=true"
import script from "./TheCard.vue?vue&type=script&lang=ts"
export * from "./TheCard.vue?vue&type=script&lang=ts"

import "./TheCard.vue?vue&type=style&index=0&id=22d50f3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22d50f3e"

export default script